module.exports = __webpack_public_path__ + "static/media/menu_icon.9a4b3e18.svg";